module.exports = __webpack_public_path__ + "static/img/endFire.d54b0d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/endFire.png
// module id = SzGT
// module chunks = 208